export const countries = [
    { id: 'Afghanistan', text: 'Afghanistan' },
    { id: 'Albania', text: 'Albania' },
    { id: 'Algeria', text: 'Algeria' },
    { id: 'Andorra', text: 'Andorra' },
    { id: 'Angola', text: 'Angola' },
    { id: 'Antigua and Barbuda', text: 'Antigua and Barbuda' },
    { id: 'Argentina', text: 'Argentina' },
    { id: 'Armenia', text: 'Armenia' },
    { id: 'Australia', text: 'Australia' },
    { id: 'Austria', text: 'Austria' },
    { id: 'Azerbaijan', text: 'Azerbaijan' },
    { id: 'Bahamas', text: 'Bahamas' },
    { id: 'Bahrain', text: 'Bahrain' },
    { id: 'Bangladesh', text: 'Bangladesh' },
    { id: 'Barbados', text: 'Barbados' },
    { id: 'Belarus', text: 'Belarus' },
    { id: 'Belgium', text: 'Belgium' },
    { id: 'Belize', text: 'Belize' },
    { id: 'Benin', text: 'Benin' },
    { id: 'Bhutan', text: 'Bhutan' },
    { id: 'Bolivia', text: 'Bolivia' },
    { id: 'Bosnia and Herzegovina', text: 'Bosnia and Herzegovina' },
    { id: 'Botswana', text: 'Botswana' },
    { id: 'Brazil', text: 'Brazil' },
    { id: 'Brunei', text: 'Brunei' },
    { id: 'Bulgaria', text: 'Bulgaria' },
    { id: 'Burkina Faso', text: 'Burkina Faso' },
    { id: 'Burundi', text: 'Burundi' },
    { id: 'Cabo Verde', text: 'Cabo Verde' },
    { id: 'Cambodia', text: 'Cambodia' },
    { id: 'Cameroon', text: 'Cameroon' },
    { id: 'Canada', text: 'Canada' },
    { id: 'Central African Republic', text: 'Central African Republic' },
    { id: 'Chad', text: 'Chad' },
    { id: 'Chile', text: 'Chile' },
    { id: 'China', text: 'China' },
    { id: 'Colombia', text: 'Colombia' },
    { id: 'Comoros', text: 'Comoros' },
    { id: 'Congo', text: 'Congo' },
    { id: 'Costa Rica', text: 'Costa Rica' },
    { id: 'Croatia', text: 'Croatia' },
    { id: 'Cuba', text: 'Cuba' },
    { id: 'Cyprus', text: 'Cyprus' },
    { id: 'Czech Republic', text: 'Czech Republic' },
    { id: 'Denmark', text: 'Denmark' },
    { id: 'Djibouti', text: 'Djibouti' },
    { id: 'Dominica', text: 'Dominica' },
    { id: 'Dominican Republic', text: 'Dominican Republic' },
    { id: 'Ecuador', text: 'Ecuador' },
    { id: 'Egypt', text: 'Egypt' },
    { id: 'El Salvador', text: 'El Salvador' },
    { id: 'Equatorial Guinea', text: 'Equatorial Guinea' },
    { id: 'Eritrea', text: 'Eritrea' },
    { id: 'Estonia', text: 'Estonia' },
    { id: 'Eswatini', text: 'Eswatini' },
    { id: 'Ethiopia', text: 'Ethiopia' },
    { id: 'Fiji', text: 'Fiji' },
    { id: 'Finland', text: 'Finland' },
    { id: 'France', text: 'France' },
    { id: 'Gabon', text: 'Gabon' },
    { id: 'Gambia', text: 'Gambia' },
    { id: 'Georgia', text: 'Georgia' },
    { id: 'Germany', text: 'Germany' },
    { id: 'Ghana', text: 'Ghana' },
    { id: 'Greece', text: 'Greece' },
    { id: 'Grenada', text: 'Grenada' },
    { id: 'Guatemala', text: 'Guatemala' },
    { id: 'Guinea', text: 'Guinea' },
    { id: 'Guinea-Bissau', text: 'Guinea-Bissau' },
    { id: 'Guyana', text: 'Guyana' },
    { id: 'Haiti', text: 'Haiti' },
    { id: 'Honduras', text: 'Honduras' },
    { id: 'Hungary', text: 'Hungary' },
    { id: 'Iceland', text: 'Iceland' },
    { id: 'India', text: 'India' },
    { id: 'Indonesia', text: 'Indonesia' },
    { id: 'Iran', text: 'Iran' },
    { id: 'Iraq', text: 'Iraq' },
    { id: 'Ireland', text: 'Ireland' },
    { id: 'Israel', text: 'Israel' },
    { id: 'Italy', text: 'Italy' },
    { id: 'Jamaica', text: 'Jamaica' },
    { id: 'Japan', text: 'Japan' },
    { id: 'Jordan', text: 'Jordan' },
    { id: 'Kazakhstan', text: 'Kazakhstan' },
    { id: 'Kenya', text: 'Kenya' },
    { id: 'Kiribati', text: 'Kiribati' },
    { id: 'Korea, North', text: 'Korea, North' },
    { id: 'Korea, South', text: 'Korea, South' },
    { id: 'Kosovo', text: 'Kosovo' },
    { id: 'Kuwait', text: 'Kuwait' },
    { id: 'Kyrgyzstan', text: 'Kyrgyzstan' },
    { id: 'Laos', text: 'Laos' },
    { id: 'Latvia', text: 'Latvia' },
    { id: 'Lebanon', text: 'Lebanon' },
    { id: 'Lesotho', text: 'Lesotho' },
    { id: 'Liberia', text: 'Liberia' },
    { id: 'Libya', text: 'Libya' },
    { id: 'Liechtenstein', text: 'Liechtenstein' },
    { id: 'Lithuania', text: 'Lithuania' },
    { id: 'Luxembourg', text: 'Luxembourg' },
    { id: 'Madagascar', text: 'Madagascar' },
    { id: 'Malawi', text: 'Malawi' },
    { id: 'Malaysia', text: 'Malaysia' },
    { id: 'Maldives', text: 'Maldives' },
    { id: 'Mali', text: 'Mali' },
    { id: 'Malta', text: 'Malta' },
    { id: 'Marshall Islands', text: 'Marshall Islands' },
    { id: 'Mauritania', text: 'Mauritania' },
    { id: 'Mauritius', text: 'Mauritius' },
    { id: 'Mexico', text: 'Mexico' },
    { id: 'Micronesia', text: 'Micronesia' },
    { id: 'Moldova', text: 'Moldova' },
    { id: 'Monaco', text: 'Monaco' },
    { id: 'Mongolia', text: 'Mongolia' },
    { id: 'Montenegro', text: 'Montenegro' },
    { id: 'Morocco', text: 'Morocco' },
    { id: 'Mozambique', text: 'Mozambique' },
    { id: 'Myanmar', text: 'Myanmar' },
    { id: 'Namibia', text: 'Namibia' },
    { id: 'Nauru', text: 'Nauru' },
    { id: 'Nepal', text: 'Nepal' },
    { id: 'Netherlands', text: 'Netherlands' },
    { id: 'New Zealand', text: 'New Zealand' },
    { id: 'Nicaragua', text: 'Nicaragua' },
    { id: 'Niger', text: 'Niger' },
    { id: 'Nigeria', text: 'Nigeria' },
    { id: 'North Macedonia', text: 'North Macedonia' },
    { id: 'Norway', text: 'Norway' },
    { id: 'Oman', text: 'Oman' },
    { id: 'Pakistan', text: 'Pakistan' },
    { id: 'Palau', text: 'Palau' },
    { id: 'Palestine', text: 'Palestine' },
    { id: 'Panama', text: 'Panama' },
    { id: 'Papua New Guinea', text: 'Papua New Guinea' },
    { id: 'Paraguay', text: 'Paraguay' },
    { id: 'Peru', text: 'Peru' },
    { id: 'Philippines', text: 'Philippines' },
    { id: 'Poland', text: 'Poland' },
    { id: 'Portugal', text: 'Portugal' },
    { id: 'Qatar', text: 'Qatar' },
    { id: 'Romania', text: 'Romania' },
    { id: 'Russia', text: 'Russia' },
    { id: 'Rwanda', text: 'Rwanda' },
    { id: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
    { id: 'Saint Lucia', text: 'Saint Lucia' },
    { id: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
    { id: 'Samoa', text: 'Samoa' },
    { id: 'San Marino', text: 'San Marino' },
    { id: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
    { id: 'Saudi Arabia', text: 'Saudi Arabia' },
    { id: 'Senegal', text: 'Senegal' },
    { id: 'Serbia', text: 'Serbia' },
    { id: 'Seychelles', text: 'Seychelles' },
    { id: 'Sierra Leone', text: 'Sierra Leone' },
    { id: 'Singapore', text: 'Singapore' },
    { id: 'Slovakia', text: 'Slovakia' },
    { id: 'Slovenia', text: 'Slovenia' },
    { id: 'Solomon Islands', text: 'Solomon Islands' },
    { id: 'Somalia', text: 'Somalia' },
    { id: 'South Africa', text: 'South Africa' },
    { id: 'South Sudan', text: 'South Sudan' },
    { id: 'Spain', text: 'Spain' },
    { id: 'Sri Lanka', text: 'Sri Lanka' },
    { id: 'Sudan', text: 'Sudan' },
    { id: 'Suriname', text: 'Suriname' },
    { id: 'Sweden', text: 'Sweden' },
    { id: 'Switzerland', text: 'Switzerland' },
    { id: 'Syria', text: 'Syria' },
    { id: 'Taiwan', text: 'Taiwan' },
    { id: 'Tajikistan', text: 'Tajikistan' },
    { id: 'Tanzania', text: 'Tanzania' },
    { id: 'Thailand', text: 'Thailand' },
    { id: 'Timor-Leste', text: 'Timor-Leste' },
    { id: 'Togo', text: 'Togo' },
    { id: 'Tonga', text: 'Tonga' },
    { id: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
    { id: 'Tunisia', text: 'Tunisia' },
    { id: 'Turkey', text: 'Turkey' },
    { id: 'Turkmenistan', text: 'Turkmenistan' },
    { id: 'Tuvalu', text: 'Tuvalu' },
    { id: 'Uganda', text: 'Uganda' },
    { id: 'Ukraine', text: 'Ukraine' },
    { id: 'United Arab Emirates', text: 'United Arab Emirates' },
    { id: 'United Kingdom', text: 'United Kingdom' },
    { id: 'United States', text: 'United States' },
    { id: 'Uruguay', text: 'Uruguay' },
    { id: 'Uzbekistan', text: 'Uzbekistan' },
    { id: 'Vanuatu', text: 'Vanuatu' },
    { id: 'Vatican City', text: 'Vatican City' },
    { id: 'Venezuela', text: 'Venezuela' },
    { id: 'Vietnam', text: 'Vietnam' },
    { id: 'Yemen', text: 'Yemen' },
    { id: 'Zambia', text: 'Zambia' },
    { id: 'Zimbabwe', text: 'Zimbabwe' }
];
